import React from 'react'

import { Button, Typography } from '@barracuda-internal/bds-core'
import { useDomainPolicyAccess } from 'lib/hooks/useDomainPolicyAccess'
import { useFormatMessage } from 'lib/localization'
import { ModifiedDomainManagerItem } from 'components/pages/domains/useDomainsLogic'

interface DomainResetSectionProps {
  domain: ModifiedDomainManagerItem
  onOpenConfirmDialog: (e: React.MouseEvent<HTMLButtonElement>, domain: ModifiedDomainManagerItem) => void
  isPending: boolean
  titleClassName: string
}

const BASE_I18N_KEY = 'ess.domains'

export const DomainResetSection: React.FC<DomainResetSectionProps> = ({
  domain,
  onOpenConfirmDialog,
  isPending,
  titleClassName
}) => {
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  const { canManageDomainPolicies } = useDomainPolicyAccess(Number(domain.domainId))

  if (!canManageDomainPolicies) {
    return null
  }

  const hasUniqueSettings = domain.uniqueSettings && domain.uniqueSettings.length > 0

  return (
    <>
      <Typography className={titleClassName} variant="body2">
        {formatMessage('details.domain_specific_policies')}
      </Typography>
      {hasUniqueSettings ? (
        <Button
          variant="text"
          size="small"
          color="primary"
          disabled={isPending}
          onClick={e => onOpenConfirmDialog(e, domain)}
        >
          {formatMessage('details.reset_to_account_policies')}
        </Button>
      ) : (
        <Typography variant="body2">{formatMessage('details.account_policies')}</Typography>
      )}
    </>
  )
}
